<template>
  <div>
    <avue-crud
      :option="option"
      :data="tableData"
      ref="crud"
      :page.sync="page"
      v-model="form"
      :before-open="beforeOpenScope"
      @on-load="queryTableData"
      @refresh-change="queryTableData"
      @row-save="rowSave"
      @row-update="rowUpdate"
    >
      <template slot-scope="scope" slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permission.factoringBusinessManage_add"
          @click.stop="handleAdd(scope.row)"
          >新增
        </el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="primary"
          plain
          size="small"
          icon="el-icon-edit"
          v-if="permission.factoringBusinessManage_edit"
          @click.stop="handleEdit(scope.row, scope.index)"
          >编辑
        </el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete-solid"
          v-if="permission.factoringBusinessManage_delete"
          @click.stop="handleDel(scope.row)"
          >删除
        </el-button>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import * as api from "@/api/factoring/factoringCustomer";
import { optionConfig } from "./config";
import { mapGetters } from "vuex";
export default {
  name: "accessory",
  data() {
    return {
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      form: {},
      query: {},
      tableData: [],
      option: optionConfig(),
    };
  },
  props: {},
  watch: {},
  computed: {
    ...mapGetters(["permission"]),
  },
  components: {},
  created() {
   
  },
  methods: {
    async queryTableData() {
      let that = this;
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
        isBusiness: 1,
      };
      let res = await api.getCustbankbl(params);
      if (res.data.code == 200) {
        let list = res.data.data.records;
        this.tableData = list;
        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.msg);
      }
    },

    //新增
    rowSave(row, done, loading) {
      this.submit(row, done, loading);
    },
    //新增
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    //编辑
    handleEdit(row, index) {
      this.$refs.crud.rowEdit(row, index);
    },
    //修改
    rowUpdate(row, index, done, loading) {
      this.submit(row, done, loading);
    },
    // 新增修改 接口
    submit(row, done, loading) {
      let data = {
        ...row,
        isBusiness: 1,
      };
      api.submitCustbankbl(data).then(
        () => {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          // 数据回调进行刷新
          done(row);
          this.queryTableData();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    //删除
    handleDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return api.removeCustbankbl({ ids: row.id });
        })
        .then(() => {
          this.queryTableData();
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$refs.crud.toggleSelection();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.lpr_name {
  display: inline-block;
  margin-left: 20px;
}
/deep/ .el-table--small td {
  padding:10px !important
}
</style>

